import { render, staticRenderFns } from "./DailyAlarmsList.vue?vue&type=template&id=ea0fff54&scoped=true&"
import script from "./DailyAlarmsList.vue?vue&type=script&lang=js&"
export * from "./DailyAlarmsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea0fff54",
  null
  
)

export default component.exports